<mat-form-field style="width: 100%; margin-top: 10px;">
  <mat-label>Search</mat-label>
  <input (keyup)="searchChanged($event)" matInput name="searchField" [(ngModel)]="currentSearchTerm"
    placeholder="Search">
</mat-form-field>

<table mat-table matSort [dataSource]="dataSource" table-striped style="width: 100%">
  @for (col of display_fields; track col; let i = $index) {
    <ng-container [matColumnDef]=col>
      @if (templates[col]) {
        <th mat-header-cell class="table-header" *matHeaderCellDef mat-sort-header> {{column_names[i]}} </th>
        <td mat-cell *matCellDef="let item" class="table-cell-data" style="padding-right: 5px; max-width: 150px">
          <ng-template *ngTemplateOutlet="templates[col]; context: { $implicit: item }">
          </ng-template>
        </td>
      }
      @if (!templates[col]) {
        <th mat-header-cell class="table-header" *matHeaderCellDef mat-sort-header> {{column_names[i]}} </th>
        <td mat-cell *matCellDef="let item" class="table-cell-data" style="padding-right: 5px; max-width: 150px">
          {{item[col]}}
        </td>
      }
    </ng-container>
  }
  <tr mat-header-row *matHeaderRowDef="display_fields"></tr>
  <tr mat-row *matRowDef="let row; columns: display_fields;"></tr>
</table>
<mat-paginator pageSize="25" [length]="totalHits" (page)="onPageChange($event)"></mat-paginator>
